// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-card-agent-description .dashboard-card-col br{display:block;margin-bottom:0.8rem;content:\"\"}\n", ""]);
// Exports
module.exports = exports;
